export async function waitTillAvailable(t){for(let i=0;i<30;i++){const i=await t();if(i){return i}await new Promise(t=>setTimeout(t,50))}}